/** This sort mode is the default global mode based on LexoRank */
export const PROJECT_RANK = 'projectRank';
/** This sort mode is scoped to a view. */
export const VIEW_RANK = 'viewRank';
/** Sorted by possibly multiple fields */
export const FIELD_SORT = 'fieldSort';
